import styled from 'styled-components';

import { ContentBox } from '~/src/components/ContentBox';

export const StyledContentBox = styled(ContentBox)`
  > * + * {
    margin-top: 24px;
  }
`;

export const ButtonsBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
